import { ImageCard } from '@bnnvara/cards/src/components/ImageCard/ImageCard';
import { ContentOnImage } from '@bnnvara/cards/src/components/shared/ContentOnImage';
import { Title } from '@bnnvara/cards/src/components/shared/Title';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';

export function BrandCard({ name, image }) {
  const src = image || '/static/fallbackImages/videofallback.jpg';

  return (
    <ImageCard src={resizeImageSource(src, 500, 1)} alt={name} isSquare>
      <ContentOnImage>
        <Title>{name}</Title>
      </ContentOnImage>
    </ImageCard>
  );
}

BrandCard.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.string,
};
